import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../CSS/App.css';
import '../CSS/Blog.css';

const posts = [
  {
    path: '/blog/ai-clone',
    title: 'Personalized Conversational Agent Trained on Instagram Messages',
    tags: 'LLM Fine-tuning · Python · Senior Project',
    blurb: 'Fine-tuning a language model on my own Instagram DMs to replicate my texting style.',
    date: '2025-12-15',
  },
  {
    path: '/blog/portfolio',
    title: 'Portfolio Website',
    tags: 'React · Nginx · Self-Hosted',
    blurb: 'Building and hosting this site on my own hardware.',
    date: '2025-08-28',
  },
  {
    path: '/blog/library',
    title: 'Library Management System',
    tags: 'Java · SQL · REST API',
    blurb: 'Building the database layer and Java API for a group project.',
    date: '2025-05-15',
  },
  {
    path: '/blog/rezepe',
    title: 'Building Rezepe',
    tags: 'React · Node.js · MySQL · Self-Hosted',
    blurb: 'A fullstack recipe webapp built from scratch and hosted on my own home server.',
    date: '2025-03-06',
  },
  {
    path: '/blog/capy-jump',
    title: 'Capy Jump',
    tags: 'Godot · GDScript · Game Dev',
    blurb: 'Making a Flappy Bird clone in Godot and the surprisingly tricky part of game feel.',
    date: '2024-02-08',
  },
  {
    path: '/blog/home-nas',
    title: 'Home NAS Solution',
    tags: 'Docker · Nginx · Ubuntu Server',
    blurb: 'Rolling my own self-hosted file storage instead of paying for cloud.',
    date: '2024-09-13',
  },
  {
    path: '/blog/ubuntu-lab',
    title: 'Ubuntu Home Lab',
    tags: 'Linux · Networking · Self-Hosted',
    blurb: 'Turning an old ThinkPad into a home server and what I learned from it.',
    date: '2024-08-28',
  },
];

const formatDate = (d) => {
  const [y, m, day] = d.split('-').map(Number);
  return new Date(y, m - 1, day).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
};

const Blog = () => {
  const [nasPosts, setNasPosts] = useState([]);

  useEffect(() => {
    fetch('/blog-posts/manifest.json')
      .then(r => r.json())
      .then(setNasPosts)
      .catch(() => {});
  }, []);

  const allPosts = [
    ...nasPosts.map(p => ({ path: `/blog/${p.slug}`, ...p })),
    ...posts,
  ].sort((a, b) => (b.date || '').localeCompare(a.date || ''));

  return (
    <div className="blog-container">
      <p className="title">Blog</p>
      <ul className="blog-index-list">
        {allPosts.map((post) => (
          <li key={post.path} className="blog-index-item">
            <Link to={post.path} className="blog-index-link">{post.title}</Link>
            <p className="blog-index-meta">{post.tags}</p>
            {post.date && <p className="blog-index-date">{formatDate(post.date)}</p>}
            <p className="blog-index-blurb">{post.blurb}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Blog;
